import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { AddProductPopupComponent } from '../components/add-product-popup/add-product-popup.component';
import { LeaveSiteConformationDialogComponent } from '../../../shared/components/leave-site-conformation-dialog/leave-site-conformation-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})

export class DirtyCheckGuardGuard implements CanDeactivate<AddProductPopupComponent> {

  constructor(public dialog: MatDialog) {}
  canDeactivate( component: AddProductPopupComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    if (nextState.url.split('/')[3] != 'detail' && nextState.url.split('/')[2] != 'customizedproducts' && nextState.url.split('/')[2] != 'viewemdproduct' )
      return confirm('There are changes you have made to the page. If you quit, you will lose your changes.');
    else
      return true;
    }

}
